// import { useState } from 'react';
// import { brandsApi, suppliersApi } from '../api';
// import { useData, submitForm, useSubmit } from '../hooks/useData';
// import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, CancelBtn, ImgPreview } from '../components/common';
// import { getBDDate } from '../utils/dateUtils';

// const EMPTY = { supplier_id: '', brand_name: '', starting_date: getBDDate(), remarks: '', active_yes_no: 1 };

// export default function BrandsPage() {
//   const { data, loading, reload } = useData(brandsApi.list);
//   const { data: suppliers }       = useData(suppliersApi.list);
//   const [modal, setModal]         = useState(null);
//   const [form, setForm]           = useState(EMPTY);
//   const [imgFile, setImgFile]     = useState(null);
//   const openAdd  = ()    => { setForm(EMPTY); setImgFile(null); setModal('add'); };
//   const openEdit = (row) => { setForm(row);   setImgFile(null); setModal('edit'); };
//   const close    = ()    => setModal(null);
//   const set      = e     => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
//   const handleSave = () => {
//     const fd = new FormData();
//     Object.entries(form).forEach(([k, v]) => v != null && fd.append(k, v));
//     if (imgFile) fd.append('image', imgFile);
//     if (modal === 'add') doSubmit(() => brandsApi.create(fd), 'Brand added', reload, close);
//     else doSubmit(() => brandsApi.update(form.id, fd), 'Brand updated', reload, close);
//   };
//   return (
//     <div>
//       <PageHeader title="Brands" subtitle="Manage your brand catalog"
//         action={<button className="btn btn-primary btn-sm" onClick={openAdd}>+ Add Brand</button>} />
//       <div className="card">
//         {loading ? <Spinner /> : (
//           <div className="table-wrap">
//             {data.length === 0 ? <Empty msg="No brands yet" /> : (
//               <table className="responsive-table">
//                 <thead><tr><th>Brand</th><th>Supplier</th><th>Since</th><th>Status</th><th>Actions</th></tr></thead>
//                 <tbody>{data.map(r => (
//                   <tr key={r.id}>
//                     <td data-label="Brand">
//                       <div style={{ display:'flex', alignItems:'center', gap:8, justifyContent:'flex-end' }}>
//                         <span className="td-primary">{r.brand_name}</span>
//                         <ImgPreview src={r.image} small />
//                       </div>
//                     </td>
//                     <td data-label="Supplier">{r.supplier_name}</td>
//                     <td data-label="Since" className="text-muted">{r.starting_date}</td>
//                     <td data-label="Status"><span className={`badge ${r.active_yes_no ? 'badge-active' : 'badge-inactive'}`}>{r.active_yes_no ? 'Active' : 'Inactive'}</span></td>
//                     <td data-label="Actions"><div className="action-cell">
//                       <EditBtn onClick={() => openEdit(r)} />
//                       {r.active_yes_no === 1 && <CancelBtn onClick={() => submitForm(() => brandsApi.deactivate(r.id), 'Deactivated', reload)} />}
//                     </div></td>
//                   </tr>
//                 ))}</tbody>
//               </table>
//             )}
//           </div>
//         )}
//       </div>
//       {modal && (
//         <Modal title={modal === 'add' ? 'Add Brand' : 'Edit Brand'} onClose={close}
//           footer={<><button className="btn btn-secondary" onClick={close}>Cancel</button><button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : 'Save Brand'}</button></>}>
//           <div className="form-row form-row-2">
//             <Field label="Supplier" required>
//               <select name="supplier_id" value={form.supplier_id} onChange={set}>
//                 <option value="">Select supplier…</option>
//                 {suppliers.filter(s => s.active_yes_no).map(s => <option key={s.id} value={s.id}>{s.full_name}</option>)}
//               </select>
//             </Field>
//             <Field label="Brand Name" required><input type="text" name="brand_name" value={form.brand_name} onChange={set} autoFocus /></Field>
//           </div>
//           <div className="form-row form-row-2">
//             <Field label="Starting Date"><input type="date" name="starting_date" value={form.starting_date} onChange={set} /></Field>
//             <Field label="Brand Image">
//               <input type="file" accept="image/*" onChange={e => setImgFile(e.target.files[0])} />
//               {form.image && !imgFile && <ImgPreview src={form.image} small />}
//             </Field>
//           </div>
//           <Field label="Remarks"><textarea name="remarks" value={form.remarks || ''} onChange={set} rows={2} /></Field>
//           {modal === 'edit' && (
//             <Field label="Status">
//               <select name="active_yes_no" value={form.active_yes_no} onChange={e => setForm(f => ({ ...f, active_yes_no: Number(e.target.value) }))}>
//                 <option value={1}>Active</option><option value={0}>Inactive</option>
//               </select>
//             </Field>
//           )}
//         </Modal>
//       )}
//     </div>
//   );
// }
import { useState } from 'react';
import { brandsApi, suppliersApi } from '../api';
import { useData, submitForm, useSubmit } from '../hooks/useData';
import { Spinner, Modal, PageHeader, Field, Empty, EditBtn, CancelBtn, ImgPreview } from '../components/common';

const EMPTY = { supplier_id: '', brand_name: '', starting_date: new Date().toISOString().slice(0,10), remarks: '', active_yes_no: 1 };

export default function BrandsPage() {
  const { data, loading, reload } = useData(brandsApi.list);
  const { data: suppliers }       = useData(suppliersApi.list);
  const [modal, setModal]         = useState(null);
  const [form, setForm]           = useState(EMPTY);
  const [imgFile, setImgFile]     = useState(null);
  const [doSubmit, saving]        = useSubmit();

  const openAdd  = ()    => { setForm(EMPTY); setImgFile(null); setModal('add'); };
  const openEdit = (row) => { setForm(row);   setImgFile(null); setModal('edit'); };
  const close    = ()    => setModal(null);
  const set      = e     => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSave = () => {
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => v != null && fd.append(k, v));
    if (imgFile) fd.append('image', imgFile);
    if (modal === 'add') doSubmit(() => brandsApi.create(fd), 'Brand added', reload, close);
    else doSubmit(() => brandsApi.update(form.id, fd), 'Brand updated', reload, close);
  };

  return (
    <div>
      <PageHeader title="Brands" subtitle="Manage your brand catalog"
        action={<button className="btn btn-primary btn-sm" onClick={openAdd}>+ Add Brand</button>} />
      <div className="card">
        {loading ? <Spinner /> : (
          <div className="table-wrap">
            {data.length === 0 ? <Empty msg="No brands yet" /> : (
              <table className="responsive-table">
                <thead><tr><th>Brand</th><th>Supplier</th><th>Since</th><th>Status</th><th>Actions</th></tr></thead>
                <tbody>{data.map(r => (
                  <tr key={r.id}>
                    <td data-label="Brand">
                      <div style={{ display:'flex', alignItems:'center', gap:8, justifyContent:'flex-end' }}>
                        <span className="td-primary">{r.brand_name}</span>
                        <ImgPreview src={r.image} small />
                      </div>
                    </td>
                    <td data-label="Supplier">{r.supplier_name}</td>
                    <td data-label="Since" className="text-muted">{r.starting_date}</td>
                    <td data-label="Status"><span className={`badge ${r.active_yes_no ? 'badge-active' : 'badge-inactive'}`}>{r.active_yes_no ? 'Active' : 'Inactive'}</span></td>
                    <td data-label="Actions"><div className="action-cell">
                      <EditBtn onClick={() => openEdit(r)} />
                      {r.active_yes_no === 1 && <CancelBtn onClick={() => submitForm(() => brandsApi.deactivate(r.id), 'Deactivated', reload)} />}
                    </div></td>
                  </tr>
                ))}</tbody>
              </table>
            )}
          </div>
        )}
      </div>
      {modal && (
        <Modal title={modal === 'add' ? 'Add Brand' : 'Edit Brand'} onClose={close}
          footer={<><button className="btn btn-secondary" onClick={close}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : 'Save Brand'}</button></>}>
          <div className="form-row form-row-2">
            <Field label="Supplier" required>
              <select name="supplier_id" value={form.supplier_id} onChange={set}>
                <option value="">Select supplier…</option>
                {suppliers.filter(s => s.active_yes_no).map(s => <option key={s.id} value={s.id}>{s.full_name}</option>)}
              </select>
            </Field>
            <Field label="Brand Name" required><input type="text" name="brand_name" value={form.brand_name} onChange={set} autoFocus /></Field>
          </div>
          <div className="form-row form-row-2">
            <Field label="Starting Date"><input type="date" name="starting_date" value={form.starting_date} onChange={set} /></Field>
            <Field label="Brand Image">
              <input type="file" accept="image/*" onChange={e => setImgFile(e.target.files[0])} />
              {form.image && !imgFile && <ImgPreview src={form.image} small />}
            </Field>
          </div>
          <Field label="Remarks"><textarea name="remarks" value={form.remarks || ''} onChange={set} rows={2} /></Field>
          {modal === 'edit' && (
            <Field label="Status">
              <select name="active_yes_no" value={form.active_yes_no} onChange={e => setForm(f => ({ ...f, active_yes_no: Number(e.target.value) }))}>
                <option value={1}>Active</option><option value={0}>Inactive</option>
              </select>
            </Field>
          )}
        </Modal>
      )}
    </div>
  );
}